import React from 'react'
import styled from 'styled-components'

const Disclaimer = ({ children }) => {
  return <Wrapper className="disclaimer">{children}</Wrapper>
}

const Wrapper = styled.p`
  font-size: var(--font-size-0);
  line-height: var(--font-lineheight-0);
`

export default Disclaimer
